import uniqId from 'lodash/uniqueId'
import {
  SHOW_TOAST,
  CLOSE_TOAST,
  CANCEL_TOAST_CLOSING
} from './'

const DEFAULT_CLOSING_TIMEOUT = 3000

export function showToast(message, options = {}) {
  const id = uniqId()
  return dispatch => {
    if (!message) return

    dispatch({
      type: SHOW_TOAST,
      message,
      options,
      id
    })

    if (options.timeout !== 0) {
      const timeout = options.timeout || (message.split(' ').length * 350) + 1000 // 350 ms per world + 1 second
      dispatch(closeToastWithTimeout(id, timeout))
    }
  }
}

export function showErrorToast(message) {
  return showToast(message, {type: 'error'})
}

export function closeToast(id) {
  clearTimeout(timeouts[id])

  return {
    type: CLOSE_TOAST,
    id
  }
}

const timeouts = {}
export function closeToastWithTimeout(id, timeout = DEFAULT_CLOSING_TIMEOUT) {
  return dispatch => {
    timeouts[id] = setTimeout(() => {
      dispatch(closeToast(id))
    }, timeout)
  }
}

export function cancelToastClosing(id) {
  clearTimeout(timeouts[id])
  return {type: CANCEL_TOAST_CLOSING}
}



// WEBPACK FOOTER //
// ./client/redux/modules/ui/toaster/actions.js